export default __webpack_public_path__ + "static/media/img_baseBunnyCrochet_grey.986f2515.jpg";